export default __webpack_public_path__ + "static/media/pptSlide111.b021ffe5.jpg";